export { default as PdfView } from "./pdfView";
export { default as StaticPdfViewer } from "./staticPdfViewer";
